import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid2';
import { FastField } from 'formik';

const FormCheckbox = ({ fullWidth, size, ...rest }) => {
  return (
    <Grid size={{ xs: fullWidth ? 12 : size }} style={rest.style}>
      <FastField {...rest}>
        {({ field }) => {
          return (
            <FormControlLabel
              control={
                <Checkbox {...field} checked={field.value} value={undefined} />
              }
              label={rest.label}
            />
          );
        }}
      </FastField>
    </Grid>
  );
};

FormCheckbox.defaultProps = {
  size: 6,
};

export default FormCheckbox;
